import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Slider from "react-slick";
import { Formik, Form, Field, useFormik } from "formik";
import * as Yup from "yup"
import axios from 'axios';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import ShapeAnimation from '../../ShapeAnimation';
import Swal from 'sweetalert2';
import $ from "jquery";
const settings = {
  // dots: true,
  nav: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  lazyLoad: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const BecomePartnerContent = () => {
  useEffect(() => {
    $(document).ready(function () {
      $('.span-tag-po').hide();
      $('.dob-cus-dv input').css("color", "transparent");
      $(".dob-cus-dv input").on('focus', function () {
        $('.dob-cus-dv label').hide();
        $('.span-tag-po').show();
        $('.dob-cus-dv input').css("color", "#5543ca");
      });
    });
  }, [])

  const handleFileChange = (event, setFieldValue, fieldName) => {
    const files = event.currentTarget.files;
    setFieldValue(fieldName, files);
  };
  const initialValues = {
    name: "",
    email: "",
    mobile: "",
    // perferred_contact_method: "",
    message: "",
  };
  const becomePartnerobj = [
    {
      id: 1,
      heading: "Lucrative Earning Potential",
      para: "Unlock unlimited earning potential by collaborating with a dynamic IT Company. Your efforts directly impact your income, giving you the freedom to achieve your financial goals.",
    },
    {
      id: 2,
      heading: "Cutting-Edge IT Solutions",
      para: "Represent innovative, industry-leading IT products and services that are in high demand. You'll be offering solutions that businesses need to stay competitive in today's digital landscape.",
    },
    {
      id: 3,
      heading: "Comprehensive Training",
      para: "Gain access to top-notch training programs that empower you with in-depth product knowledge and sales techniques. No prior IT experience? No problem! We provide the tools you need to succeed.",
    },
    {
      id: 4,
      heading: "Flexible Work Structure",
      para: "Work on your terms! Whether you're seeking a part-time venture or a full-time career, our flexible work structure accommodates your schedule and lifestyle.",
    },
    {
      id: 5,
      heading: "Professional Growth",
      para: "Seize opportunities for personal and professional development. Network with IT experts, expand your skills, and enhance your career trajectory.",
    },
  ]
  const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let today = new Date().toISOString().split('T')[0];
  //Formik Form Submission:
  const formik = useFormik({
    initialValues: initialValues,

    validationSchema: Yup.object({
      name: Yup.string()
        .min(2, 'Must be 2 characters or more')
        .max(30, 'Must be 30 characters or less')
        .matches(/^[a-zA-Z _)]+$/, "Name should contain only Alphabets")
        .required('Name is required'),
      email: Yup.string().matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, "Enter a valid E-mail")
        .required('Email is required'),
      mobile: Yup.string()
        .required('Mobile No. is required')
        .matches(/^[0-9]+$/, "Must contain digits only.")
        .min(8, 'Must be minimum 8 digits')
        .max(15, 'Must be maximum 15 digits'),
      // perferred_contact_method: Yup.string()
      //   .required('This field is required'),
      // message: Yup.string()
      //   .required('This field is required.')
    }),

    onSubmit: (values, { resetForm }) => {

      let timerInterval;
      Swal.fire({
        title: 'Please Wait...',
        html: 'Your query is being submitted.',
        timer: 30000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
          // const b = Swal.getHtmlContainer().querySelector('b')
          timerInterval = setInterval(() => {
            //   b.textContent = Swal.getTimerLeft()
          }, 100)
        },
        willClose: () => {
          clearInterval(timerInterval)
        }

      })
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      const formData = new FormData();
      // formData.append("name", values.name)
      // formData.append("email", values.email)
      // formData.append("mobile", values.mobile)
      // formData.append("perferred_contact_method", values.perferred_contact_method);
      // formData.append("message", values.message);


      // axios.post('https://alobhaapi.alobhatech.com/post-associate-partner', formData, config) //for files
      // axios.post('http://localhost:1995/post-associate-partner', values)
      // axios.post('https://tapi.alobhatech.com/post-associate-partner', values)
      axios.post('https://www.alobhaapi.alobhatech.com/post-associate-partner', values)
        .then(function (response) {
          if (response.status == 200) {
            Swal.fire(
              'Congratulations.',
              'We will revert back to you.',
              'success'
            )
            resetForm();
            $('#exampleModal').modal('hide');

          } else if (response.status == 201) {
            // console.log(`Success!`)
            Swal.fire(
              'Warning',
              'This email already exists.',
              'warning'
            )
            // resetForm();
            // $('#exampleModal').modal('hide');

          } else if (response.status == 202) {
            // console.log(`Success!`)
            Swal.fire(
              'Warning',
              'This Mobile No. already exists.',
              'warning'
            )
            // resetForm();
            // $('#exampleModal').modal('hide');

          } else {
            Swal.fire(
              'Please try again.',
              'Something went wrong',
              'error'
            )
            $('#exampleModal').modal('hide');

          }
        })
        .catch(function (error) {
          console.log(`Error:`, error.response)
          Swal.fire(
            'Server Error, Please try again later.',
            'Internal Server Error',
            'error'
          )
          $('#exampleModal').modal('hide');

        })
      document.getElementById('user_captcha_input').value = "";

    }
  });
  return (
    <>
      <div className=''>
        <section className="become-content-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className='becomefirst-div'>
                  {/* <span>Become a Partner</span> */}
                  <h2>Introducing the Ultimate Business Associate Opportunity & Partnership program in the IT World!</h2>
                  <p> <strong>Are you ready to take your business to new heights? </strong> Look no further, because Alobha Technologies Pvt Ltd is your gateway to technological excellence and business prosperity. We're on the lookout for dynamic Business Associates and Sales Partners to join hands with us in revolutionizing the IT landscape.</p>
                  <p>Seize this opportunity to earn not just incentives, but also the satisfaction of connecting businesses with cutting-edge solutions.</p>
                  <h4>Why Join Us as a Business Associate? </h4>
                  <p>When you become a Business Associate or Sales Partner with Alobha Technologies Pvt Ltd, you're opening doors to unparalleled growth and earning potential. Here's why this partnership is your gateway to success:</p>
                </div>
              </div>
              <div className="col-lg-4">
                <img src="assets/become-partner.webp" className="img-fluid" />
              </div>
            </div>
            {/* <div className='row'>
              <div className='col-md-12'>
                <div className="main-slide" >
                  <div className="slider slider-nav-n" data-slick='{"slidesToShow": 4, "slidesToScroll": 4}'>
                    <Slider {...settings}>
                      {becomePartnerobj.map((featurcard) => {
                        return <div className="serviceBox" key={featurcard.id}>
                          <h3 className="title">{featurcard.heading}</h3>
                          <p className="description">{featurcard.para}</p>
                        </div>
                      })}
                    </Slider>
                  </div>
                </div>
              </div>
            </div> */}

            <div className='after-banner-dv mt-2'>
              <div className='row'>
                <div className='col-md-12'>
                  <div>
                    <ul>
                      <li>
                        <div className="icon"><i className="fa fa-home" /></div>
                        <div className="title">Work from home</div>
                      </li>
                      <li>
                        <div className="icon"><i className="fa fa-clock-o" /></div>
                        <div className="title">Time flexibility</div>
                      </li>
                      <li>
                        <div className="icon"><i className="fa fa-user" /></div>
                        <div className="title">Attractive Incentives & Recognition</div>
                      </li>
                      <li>
                        <div className="icon"><i className="fa fa-handshake-o" /></div>
                        <div className="title">Be a Trusted Advisor for your customers</div>
                      </li>

                      <li>
                        <div className="icon"><i className="fa fa-laptop" /></div>
                        <div className="title">Free Training & Support system</div>
                      </li>
                      <li>
                        <div className="icon"><i className="fa fa-globe" /></div>
                        <div className="title">Deliver world-class service through us to your customers</div>
                      </li>
                    </ul>
                  </div >
                </div >
              </div >
            </div>
          </div >
        </section >
        <section className='become-partner-second-section'>
          <div className="container">
            <div className="row">
              <div className='col-md-12'>
                <div className='become-service-right'>
                  <div className='become-ser-f-dv'>
                    <h4>Who We Are? </h4>
                    <p>Alobha Technologies Pvt Ltd is a trailblazing IT company at the forefront of innovation. With a proven track record of delivering top-notch software solutions and IT services, we've carved a niche for ourselves in the industry. </p>
                  </div>
                </div>
              </div>




              <div className="col-md-12">
                <div className="container">
                  <div className="main-timeline">
                    <div className='custom-row-become-part'>
                      {/* <div className='col-lg-1'></div> */}
                      <div className="head-timeline">
                        <div className="timeline green">
                          <a href="#" className="timeline-content">
                            <div className="timeline-year">
                              {/* <span>2018</span> */}
                            </div>
                            <div className="inner-content">
                              <div className="timeline-icon">
                                <i className="fa fa-globe" />
                              </div>
                              <h3 className="title">Custom Website <br /> Development</h3>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="head-timeline">
                        <div className="timeline blue">
                          <a href="#" className="timeline-content">
                            <div className="timeline-year">
                              {/* <span>2017</span> */}
                            </div>
                            <div className="inner-content">
                              <div className="timeline-icon">
                                <i className="fa fa-mobile" />
                              </div>
                              <h3 className="title">Mobile App  <br /> Development</h3>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="head-timeline">
                        <div className="timeline orange">
                          <a href="#" className="timeline-content">
                            <div className="timeline-year">
                              {/* <span>2016</span> */}
                            </div>
                            <div className="inner-content">
                              <div className="timeline-icon">
                                <i className="fa fa-connectdevelop"></i>
                              </div>
                              <h3 className="title">ERP  <br /> Development</h3>

                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="head-timeline">
                        <div className="timeline lightgreen">
                          <a href="#" className="timeline-content">
                            <div className="timeline-year">
                              {/* <span>2015</span> */}
                            </div>
                            <div className="inner-content">
                              <div className="timeline-icon">
                                <i className="fa fa-file-text"></i>
                              </div>
                              <h3 className="title">CMS  <br /> Development</h3>

                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="head-timeline">
                        <div className="timeline ">
                          <a href="#" className="timeline-content">
                            <div className="timeline-year">
                              {/* <span>2015</span> */}
                            </div>
                            <div className="inner-content">
                              <div className="timeline-icon">
                                <i className="fa fa-rocket"></i>
                              </div>
                              <h3 className="title">Digital  <br /> Marketing</h3>

                            </div>
                          </a>
                        </div>
                      </div>
                      {/* <div className='col-lg-1'></div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-12'>
                <div className='become-service-right'>
                  <div className='become-ser-s-dv'>
                    <h4>What You Have to Do? </h4>
                    <p>As a valued Business Associate or Sales Partner, your role will be pivotal in driving business growth. Your responsibilities will include: </p>
                    <ul className='become-ul'>
                      <li>Identifying potential clients and leads that can benefit from our IT services.</li>
                      <li>Engaging with prospects, understanding their needs, and presenting our solutions effectively.</li>
                      <li>Nurturing relationships and serving as a bridge between clients and our technical team.</li>
                      <li>Contributing to the expansion of our client base and the success of Alobha Technologies Pvt Ltd.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='become-part-apply-btn'>
          <div className="container">
            <div className="row">
              <div className='col-md-12 text-center'>
                <div className='become-app-sec-para'>
                  <h4>Join Our Team Today! </h4>
                  {/* <h5>Ready to Embark on a Journey of Success? </h5> */}
                  <p>If you're driven, ambitious, and excited about making a mark in the IT industry, we want you on our team. Let's shape the future together, one innovative solution at a time. Your journey towards financial success and personal growth starts here!</p>
                </div>
                <button className="btn btn-lg apply-btn-modal" type="button" data-toggle="modal" data-target="#exampleModal">
                  <span>Apply Now and Ignite Your IT Business Career!</span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div >
      <section className="modal-section">
        <div className="modal fade" id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel"
          aria-hidden="true" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h3 style={{ fontSize: 20 }} className="modal-title" id="exampleModalLabel">Become a Partner</h3>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <section className="become-partner-form-field">
                  <section className="get-in-touch">

                    <form className="contact-form row" onSubmit={formik.handleSubmit} method="POST">
                      <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Please fill out these details</h5></div>
                      </div>
                      <div className="form-field col-lg-6">
                        <input id="name" className="input-text js-input" type="text" required="" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.name} placeholder="Full Name*" />
                        <div className="help-block with-errors">
                          {formik.touched.name && formik.errors.name ? (
                            <div className='text-danger'>*{formik.errors.name}</div>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-field col-lg-6 ">
                        <input id="email" className="input-text js-input" type="email" required="" name="email" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email} placeholder="Email*" />
                        <div className="help-block with-errors">
                          {formik.touched.email && formik.errors.email ? (
                            <div className='text-danger'>*{formik.errors.email}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="mobile" className="input-text js-input" type="text" required="" name="mobile" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.mobile} placeholder="Phone*" />
                        <div className="help-block with-errors">
                          {formik.touched.mobile && formik.errors.mobile ? (
                            <div className='text-danger'>*{formik.errors.mobile}</div>
                          ) : null}
                        </div>
                      </div>
                      {/* <div className="form-field col-lg-6">
                        <select id="perferred_contact_method" className="form-select input-text js-input" aria-label="Default select example" name="perferred_contact_method" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.perferred_contact_method}>
                          <option selected>Preferred Contact Method</option>
                          <option value="Email">Email</option>
                          <option value="Phone">Phone</option>
                        </select>
                        <div className="help-block with-errors">
                          {formik.touched.perferred_contact_method && formik.errors.perferred_contact_method ? (
                            <div className='text-danger'>*{formik.errors.perferred_contact_method}</div>
                          ) : null}
                        </div>
                      </div> */}
                      <div className="form-field col-lg-6">
                        <textarea className="input-text js-input" name="message" id="message" cols="30" rows="10" required="" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.message} placeholder="Enter your message"></textarea>
                        <div className="help-block with-errors">
                          {formik.touched.message && formik.errors.message ? (
                            <div className='text-danger'>*{formik.errors.message}</div>
                          ) : null}
                        </div>
                      </div>
                      {/* <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Address Information</h5></div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="street-address" className="input-text js-input" type="text" required="" name="street" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.street} placeholder="Street Address" />
                        <div className="help-block with-errors">
                          {formik.touched.street && formik.errors.street ? (
                            <div className='text-danger'>*{formik.errors.street}</div>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-field col-lg-6 ">
                        <input id="city" className="input-text js-input" type="text" required="" name="city" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.city} placeholder="City" />
                        <div className="help-block with-errors">
                          {formik.touched.city && formik.errors.city ? (
                            <div className='text-danger'>*{formik.errors.city}</div>
                          ) : null}
                        </div>
                      </div> */}
                      {/* <div className="form-field col-lg-6">
                        <select className="form-select input-text js-input" aria-label="Default select example" name="state" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.state}>
                          <option selected>State/Province</option>
                          <option value="1">UP</option>
                          <option value="2">BR</option>
                          <option value="3">MP</option>
                        </select>
                        <input id="state" className="input-text js-input" type="text" required="" name="state" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.state} placeholder="State" />
                        <div className="help-block with-errors">
                          {formik.touched.state && formik.errors.state ? (
                            <div className='text-danger'>*{formik.errors.state}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="postal-code" className="input-text js-input" type="text" required="" name="postal_code" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.postal_code} placeholder="Postal Code" />
                        <div className="help-block with-errors">
                          {formik.touched.postal_code && formik.errors.postal_code ? (
                            <div className='text-danger'>*{formik.errors.postal_code}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="country" className="input-text js-input" type="text" required="" name="country" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.country} placeholder="Country" />
                        <div className="help-block with-errors">
                          {formik.touched.country && formik.errors.country ? (
                            <div className='text-danger'>*{formik.errors.country}</div>
                          ) : null}
                        </div>
                      </div> */}
                      {/* <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Professional Information</h5></div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="current-job-title" className="input-text js-input" type="text" required="" name="current_job_title" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.current_job_title} placeholder="Current Job Title" />
                        <div className="help-block with-errors">
                          {formik.touched.current_job_title && formik.errors.current_job_title ? (
                            <div className='text-danger'>*{formik.errors.current_job_title}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="current-company" className="input-text js-input" type="text" required="" name="current_company" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.current_company} placeholder="Current Company (if applicable)" />
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="industry-experience" className="input-text js-input" type="text" required="" name="industry_exp" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.industry_exp} placeholder="Industry Experience" />
                        <div className="help-block with-errors">
                          {formik.touched.industry_exp && formik.errors.industry_exp ? (
                            <div className='text-danger'>*{formik.errors.industry_exp}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="linkedin-profile" className="input-text js-input" type="text" required="" name="linkedin" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.linkedin} placeholder="LinkedIn Profile" />
                        <div className="help-block with-errors">
                          {formik.touched.linkedin && formik.errors.linkedin ? (
                            <div className='text-danger'>*{formik.errors.linkedin}</div>
                          ) : null}
                        </div>
                      </div> */}
                      {/*<div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Business Information</h5></div>
                      </div>
                       <div className="form-field col-lg-6 ">
                        <input id="company_name" className="input-text js-input" type="text" required="" name="company_name" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.company_name} placeholder="Company Name (if applicable)"/>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="company-website" className="input-text js-input" type="text" required="" name="company_website" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.company_website} placeholder="Company Website (if applicable) "/>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="business-address" className="input-text js-input" type="text" required="" name="business_address" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.business_address} placeholder="Business Address (if different from personal)"/>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="business-discription" className="input-text js-input" type="text" required="" name="business_desc" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.business_desc} placeholder="Business Description"/>
                      </div> */}
                      {/* <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Motivation and Interest</h5></div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="briefly" className="input-text js-input" type="text" required="" name="why_associate_sales_partner" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.why_associate_sales_partner} placeholder="Briefly explain why you're interested in becoming an associate sales partner."/>
                        <div className="help-block with-errors">
                          {formik.touched.why_associate_sales_partner && formik.errors.why_associate_sales_partner ? (
                            <div className='text-danger'>*{formik.errors.why_associate_sales_partner}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6 ">
                        <input id="what-quality" className="input-text js-input" type="text" required="" name="qualities" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.qualities} placeholder="What qualities/skills do you believe make you a good fit for this role?"/>
                        <div className="help-block with-errors">
                          {formik.touched.qualities && formik.errors.qualities ? (
                            <div className='text-danger'>*{formik.errors.qualities}</div>
                          ) : null}
                        </div>
                      </div> */}
                      {/* <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Referral Source</h5></div>
                      </div>
                      <div className="form-field col-lg-12">
                        <select id='referral' className="form-select input-text js-input" aria-label="Default select example" name="referral" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.referral}>
                          <option selected>How did the applicant learn about the associate sales partner opportunity? </option>
                          <option value="Website">Website</option>
                          <option value="Referral">Referral</option>
                          <option value="Social Media">Social Media</option>
                        </select>
                        <div className="help-block with-errors">
                          {formik.touched.referral && formik.errors.referral ? (
                            <div className='text-danger'>*{formik.errors.referral}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Availability and Commitment</h5></div>
                      </div>
                      <div className="form-field col-lg-6">
                        <select id='' className="form-select input-text js-input" aria-label="Default select example" name="availability" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.availability}>
                          <option selected >Availability </option>
                          <option value="Part-time">Part-time</option>
                          <option value="Full-time">Full-time</option>
                        </select>
                        <div className="help-block with-errors">
                          {formik.touched.availability && formik.errors.availability ? (
                            <div className='text-danger'>*{formik.errors.availability}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6">
                        <input id="many-hours" className="input-text js-input" type="text" required="" name="hours_per_week" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.hours_per_week} placeholder="How many hours per week can you commit to this role?" />
                        
                        <div className="help-block with-errors">
                          {formik.touched.hours_per_week && formik.errors.hours_per_week ? (
                            <div className='text-danger'>*{formik.errors.hours_per_week}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Agreements and Consent</h5></div>
                      </div>
                      <div className="form-field col-lg-6">
                        <div className='checkbox-cus-hd'>
                          <input id="share_info" className="" type="checkbox" required="" name="share_info" onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.share_info} />
                          <label className="label" htmlFor="share_info"> Consent to share personal and professional information for verification purposes.</label>
                        </div>
                        <div className="help-block with-errors">
                          {formik.touched.share_info && formik.errors.share_info ? (
                            <div className='text-danger'>*{formik.errors.share_info}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6">
                        <div className='checkbox-cus-hd'>
                          <input id="tnc" className="" type="checkbox" required="" name="tnc" onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.tnc} />
                          <label className="label" htmlFor="tnc">Agreement to terms and conditions of the associate sales partner program. </label>
                        </div>
                        <div className="help-block with-errors">
                          {formik.touched.tnc && formik.errors.tnc ? (
                            <div className='text-danger'>*{formik.errors.tnc}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Uploads</h5></div>
                      </div>
                      <div className="form-field col-lg-6 form-fld-cus-dv">
                        <input id="resume" className="input-text js-input" type="file" required="" name="resume" accept="application/pdf,.docx,.doc"
                          onChange={(event) => { console.log('resume:', event.currentTarget.files); return formik.setFieldValue("resume", event.currentTarget.files[0]) }}
                          onBlur={formik.handleBlur}
                        />
                        <span style={{ fontSize: 12, color: 'red' }}>PDF or Word document</span>
                        <label className="label" htmlFor="resume">Resume/CV</label>
                        <div className="help-block with-errors">
                          {formik.touched.resume && formik.errors.resume ? (
                            <div className='text-danger'>*{formik.errors.resume}</div>
                          ) : null}
                        </div>
                      </div> */}
                      {/* <div className="form-field col-lg-6 form-fld-cus-dv">
                        <input id="cover_letter" className="input-text js-input" type="file" required="" name="cover_letter" accept="application/pdf"
                          onChange={(event) => { console.log('cover:', event.currentTarget.files); return formik.setFieldValue("cover_letter", event.currentTarget.files[0]) }}
                          onBlur={formik.handleBlur}
                        />
                        <label className="label" htmlFor="cover_letter">Cover Letter</label>
                        <div className="help-block with-errors">
                          {formik.touched.cover_letter && formik.errors.cover_letter ? (
                            <div className='text-danger'>*{formik.errors.cover_letter}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6 form-fld-cus-dv">
                        <input id="other_document" className="input-text js-input" type="file" required="" name="other_document" accept="application/pdf"
                          onChange={(e) => { console.log("other", e.target.files[0]); return formik.setFieldValue("other_document", e.target.files[0]) }}
                          onBlur={formik.handleBlur} />
                        <label className="label" htmlFor="other_documents">Any other relevant documents or certifications</label>
                        <div className="help-block with-errors">
                          {formik.touched.other_document && formik.errors.other_document ? (
                            <div className='text-danger'>*{formik.errors.other_document}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-field col-lg-6 form-fld-cus-dv">
                        <input id="id_proof" className="input-text js-input" type="file" required="" name="id_proof" accept="application/pdf"
                          onChange={(e) => { console.log("id", e.target.files[0]); return formik.setFieldValue("id_proof", e.target.files[0]) }}
                          onBlur={formik.handleBlur} />
                        <span style={{ fontSize: 12, color: 'red' }}>Adhar Card, Passport, Voter ID</span>
                        <label className="label" htmlFor="id_proof">ID Proof</label>
                        <div className="help-block with-errors">
                          {formik.touched.id_proof && formik.errors.id_proof ? (
                            <div className='text-danger'>*{formik.errors.id_proof}</div>
                          ) : null}
                        </div>
                      </div> */}
                      {/* <div className='col-lg-12'>
                        <div className='form-heading-cus'><h5>Preferred Contact Method</h5></div>
                      </div>
                      <div className="form-field col-lg-12">
                        <select id="perferred_contact_method" className="form-select input-text js-input" aria-label="Default select example" name="perferred_contact_method" onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.perferred_contact_method}>
                          <option selected>How would the applicant prefer to be contacted?</option>
                          <option value="Email">Email</option>
                          <option value="Phone">Phone</option>
                        </select>
                        <div className="help-block with-errors">
                          {formik.touched.perferred_contact_method && formik.errors.perferred_contact_method ? (
                            <div className='text-danger'>*{formik.errors.perferred_contact_method}</div>
                          ) : null}
                        </div>
                      </div> */}

                      <div className="form-field col-lg-12 text-right">
                        <input className="submit-btn submitbtnbecomepartner" type="submit" defaultValue="Submit" />
                      </div>
                    </form>
                  </section>

                </section>
              </div>
              {/* <div className="modal-footer">
                <button type="button" className="btn btn-secondary modal-footer-btn-become" data-dismiss="modal" > Close </button>
                <button type="button" className="btn btn-primary modal-footer-btn-become"> Save changes </button>
              </div> */}
            </div>
          </div>
        </div>

      </section>
    </>
  )
}

export default BecomePartnerContent